import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { CourseCard } from "../../Components/CourseCard/CourseCard";
import { useListCoursesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getSelectedFiltersFromUrl } from "core/helpers/preferencesFilter";
import { useState } from "react";

export const WisdomAcademyHome = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [selectedCategories] = useState<string[]>(getSelectedFiltersFromUrl(location));
  const {
    mutate,
    data,
    isLoading: isCoursesListLoading,
    error: coursesListError,
  } = useListCoursesFunctionRequest({ categories: selectedCategories, xClientCode: ClientInfoState.getCode() });

  const emptyMessage = <div className="w-full flex justify-center">{t("wisdomAcademy.emptyMessage")}</div>;
  const hasCourses = data?.courses && data.courses.length > 0;

  return (
    <>
      <PageTitle title={t("pageTitle.wisdomAcademy.home")} />
      <PageHeader title={t("wisdomAcademy.home.heading")} />
      <ViewStateWrapper
        onRetry={mutate}
        loading={isCoursesListLoading}
        error={!!coursesListError}
        errorMessage={t("wisdomAcademy.listCoursesErrorMessage")}
      >
        {hasCourses ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {data?.courses.map((courseData) => (
              <CourseCard key={courseData.id} courseData={courseData} />
            ))}
          </div>
        ) : (
          emptyMessage
        )}
      </ViewStateWrapper>
    </>
  );
};
